import Datadog from './datadog';

export default Datadog;
